import { Divider, Grid } from "@mui/material";
import { useSeoFormActions } from "@rf/property/module/components/property-form/store/slices/SeoFormSlice";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import SeoTitleField from "./SeoTitleField";
import { seoMessages } from "../util/seo-menssages.util";
import MxFormL3InputField from "@rf-l3/form/MxFormL3InputField";
import MxFormL3TextQuillField from "@rf-l3/form/MxFormL3TextRichField";
import { useFormContext } from "react-hook-form";
import React, { useRef } from "react";
import useAlert from "@rf-hooks/useAlert";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import useSeoTitleHelper from "../hooks/useSeoTitleHelper";
import useSeoDescriptionHelper from "../hooks/useSeoDescriptionHelper";
import useUserHelp from "@rf-hooks/useUserHelp";

function SeoStepV2Form() {
  return (
    <Grid container gap={3}>
      <Grid item xs={12}>
        <Divider
          sx={{
            color: "#000"
          }}
        >
          Español
        </Divider>
      </Grid>
      <Grid item xs={12}>
        <PropertySeoFormEs />
      </Grid>

      <Grid item xs={12}>
        <Divider
          sx={{
            color: "#000"
          }}
        >
          Inglés
        </Divider>
      </Grid>

      <Grid item xs={12}>
        <PropertySeoFormEn />
      </Grid>
    </Grid>
  );
}

export default SeoStepV2Form;

const PropertySeoFormEs = () => {
  const { onValidate, isLoadingTranslateSection, isLoadingGenerateTitle } =
    useSeoTitleHelper();

  const { onValidateDescription, isLoadingGenerateDescription } =
    useSeoDescriptionHelper();

  const { getValues } = useFormContext();
  const { alert } = useAlert();
  const { translateField } = useSeoFormActions();
  const { getPreferences, updatePreferences } = useUserHasPermission();

  const prevEsTitleRef = useRef<string | undefined>(
    getValues(CPropertyFormKeys.seo_title_es_property)
  );
  const prevEsDescRef = useRef<string | undefined>(
    getValues(CPropertyFormKeys.seo_description_es_property)
  );

  const handleEsTitleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    console.log("OTmates");
    const newVal = e?.target?.value ?? "";
    const prevVal = prevEsTitleRef.current ?? "";
    if (newVal !== prevVal) {
      if (getPreferences().formPropertyTranslationAlertIsDisable) {
        prevEsTitleRef.current = newVal;
        return;
      }
      await alert({
        type: "info",
        color: "primary.main",
        title: "Traducción",
        message: "¿Deseas traducir el título al inglés?",
        confirmBtnMessage: "Traducir",
        declineBtnMessage: "No",
        checkLabel: "No volver a preguntar"
      }).then(res => {
        if (res?.value && (res as any).value.checkValue) {
          updatePreferences({
            formPropertyTranslationAlertIsDisable: (res as any).value.checkValue
          });
          return;
        }
        if (res.type.confirm) {
          translateField("title", "es_to_en");
        }
      });
    }
    prevEsTitleRef.current = newVal;
  };

  const handleEsDescriptionBlur = async (e: {
    target: { name: string; value: string };
  }) => {
    const newVal = e?.target?.value ?? "";
    const prevVal = prevEsDescRef.current ?? "";
    if (newVal !== prevVal) {
      if (getPreferences().formPropertyTranslationAlertIsDisable) {
        prevEsDescRef.current = newVal;
        return;
      }
      await alert({
        type: "info",
        color: "primary.main",
        title: "Traducción",
        message: "¿Deseas traducir la descripción al inglés?",
        confirmBtnMessage: "Traducir",
        declineBtnMessage: "No",
        checkLabel: "No volver a preguntar"
      }).then(res => {
        if (res?.value && (res as any).value.checkValue) {
          updatePreferences({
            formPropertyTranslationAlertIsDisable: (res as any).value.checkValue
          });
          return;
        }
        if (res.type.confirm) {
          translateField("description", "es_to_en");
        }
      });
    }
    prevEsDescRef.current = newVal;
  };

  return (
    <Grid container gap={2}>
      <Grid item xs={12}>
        <SeoTitleField
          label="Titulo"
          infoButtonMsg="Generar un nuevo"
          infoIconMsg={seoMessages.title.info_description}
          keySignal="title_seo"
          onClick={onValidate}
          loading={isLoadingGenerateTitle}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3InputField
          disabled={isLoadingGenerateTitle || isLoadingTranslateSection}
          name={CPropertyFormKeys.seo_title_es_property}
          withreacthookform={1}
          onBlur={e => {
            // handleEsTitleBlur(e)
            console.log(e);
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <SeoTitleField
          label="Descripción "
          infoButtonMsg="Generar una nueva"
          infoIconMsg={seoMessages.description.info_description}
          keySignal="title_seo"
          onClick={onValidateDescription}
          loading={isLoadingGenerateDescription}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3TextQuillField
          name={CPropertyFormKeys.seo_description_es_property}
          withreacthookform={1}
          disabled={isLoadingGenerateDescription || isLoadingTranslateSection}
          onAfterBlur={handleEsDescriptionBlur}
        />
      </Grid>
    </Grid>
  );
};

const PropertySeoFormEn = () => {
  const { onValidate, isLoadingTranslateSection, isLoadingGenerateTitle } =
    useSeoTitleHelper();
  const { isLoadingGenerateDescription } = useSeoDescriptionHelper();
  const { getValues } = useFormContext();
  const { alert } = useAlert();
  const { getPreferences, updatePreferences } = useUserHelp();
  const { translateField } = useSeoFormActions();
  const prevEnTitleRef = useRef<string | undefined>(
    getValues(CPropertyFormKeys.seo_title_en_property)
  );
  const prevEnDescRef = useRef<string | undefined>(
    getValues(CPropertyFormKeys.seo_description_en_property)
  );

  const handleEnTitleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    const newVal = e?.target?.value ?? "";
    const prevVal = prevEnTitleRef.current ?? "";
    if (newVal !== prevVal) {
      if (getPreferences().formPropertyTranslationAlertIsDisable) {
        prevEnTitleRef.current = newVal;
        return;
      }
      await alert({
        type: "info",
        color: "primary.main",
        title: "Traducción",
        message: "¿Deseas traducir el título al español?",
        confirmBtnMessage: "Traducir",
        declineBtnMessage: "No",
        checkLabel: "No volver a preguntar"
      }).then(res => {
        if (res?.value && (res as any).value.checkValue) {
          updatePreferences({
            formPropertyTranslationAlertIsDisable: (res as any).value.checkValue
          });
          return;
        }
        if (res.type.confirm) {
          translateField("title", "en_to_es");
        }
      });
    }
    prevEnTitleRef.current = newVal;
  };

  const handleEnDescriptionBlur = async (e: {
    target: { name: string; value: string };
  }) => {
    const newVal = e?.target?.value ?? "";
    const prevVal = prevEnDescRef.current ?? "";
    if (newVal !== prevVal) {
      if (getPreferences().formPropertyTranslationAlertIsDisable) {
        prevEnDescRef.current = newVal;
        return;
      }
      await alert({
        type: "info",
        color: "primary.main",
        title: "Traducción",
        message: "¿Deseas traducir la descripción al español?",
        confirmBtnMessage: "Traducir",
        declineBtnMessage: "No",
        checkLabel: "No volver a preguntar"
      }).then(res => {
        if (res?.value && (res as any).value.checkValue) {
          updatePreferences({
            formPropertyTranslationAlertIsDisable: (res as any).value.checkValue
          });
          return;
        }
        if (res.type.confirm) {
          translateField("description", "en_to_es");
        }
      });
    }
    prevEnDescRef.current = newVal;
  };
  return (
    <Grid container gap={1}>
      <Grid item xs={12}>
        <SeoTitleField
          label="Titulo"
          infoButtonMsg="Generar un nuevo"
          infoIconMsg={seoMessages.title.info_description}
          keySignal="title_seo"
          onClick={onValidate}
          loading={isLoadingGenerateTitle}
        />
      </Grid>

      <Grid item xs={12}>
        <MxFormL3InputField
          name={CPropertyFormKeys.seo_title_en_property}
          withreacthookform={1}
          disabled={isLoadingGenerateTitle || isLoadingTranslateSection}
          onBlur={handleEnTitleBlur}
        />
      </Grid>

      <Grid item xs={12}>
        <SeoTitleField
          label="Descripción "
          infoButtonMsg="Generar una nueva"
          infoIconMsg={seoMessages.description.info_description}
          keySignal="title_seo"
          onClick={onValidate}
          loading={isLoadingGenerateDescription}
        />
      </Grid>
      <Grid item xs={12}>
        <MxFormL3TextQuillField
          name={CPropertyFormKeys.seo_description_en_property}
          withreacthookform={1}
          disabled={isLoadingGenerateDescription || isLoadingTranslateSection}
          onAfterBlur={handleEnDescriptionBlur}
        />
      </Grid>
    </Grid>
  );
};
